export default __webpack_public_path__ + "static/media/logosm.0b1ca6e8.png";